import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NotificationsService } from './core/notifications/notifications.service';
import { MessagesModule, Message } from 'primeng/primeng';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  // messages: Message[] = [];
  showHeader: true;
  constructor(
    private notificationsService: NotificationsService) {
  }

  ngOnInit() {
    // this.notificationsService.notificationChange.subscribe((val: Message) => {
    //   debugger;
    //   if (val){
    //     val.key = new Date().toString();
    //     //this.messages = [...this.messages,val];
    //      this.messages.push(val);
    //   }
    // });
  }


  ngAfterViewInit() {
    // this.notificationsService.notify('info', 'App component', 'ngOnInit was called!');
  }


  show() {

      throw new Error("Test Error");
    //this.notificationsService.notify('error', 'App component', 'Show me an error!');
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts